import React from 'react';
import './EdutoryCertificateCard.css';

const EdutoryCertificateCard = ({ certificate }) => {
  const getLevelColor = (level) => {
    switch (level?.toLowerCase()) {
      case 'beginner':
        return 'level-beginner';
      case 'intermediate':
        return 'level-intermediate';
      case 'advanced':
        return 'level-advanced';
      case 'professional':
        return 'level-professional';
      default:
        return 'level-default';
    }
  };

  return (
    <div className="edutory-certificate-card">
      <div className="certificate-header">
        <div className="certificate-badge">
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="certificate-icon"
          >
            <path
              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
              fill="currentColor"
            />
          </svg>
          <span className={`level-badge ${getLevelColor(certificate.level)}`}>
            {certificate.level}
          </span>
        </div>
        <div className="certificate-info">
          <h3 className="certificate-title">{certificate.title}</h3>
          <p className="certificate-provider">
            <span className="provider-label">by</span> {certificate.provider}
          </p>
        </div>
      </div>

      <div className="certificate-footer">
        <a
          href={certificate.url}
          target="_blank"
          rel="noopener noreferrer"
          className="certificate-link"
        >
          View Certificate
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="external-icon"
          >
            <path
              d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11M15 3H21M21 3V9M21 3L10 14"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default EdutoryCertificateCard;
